import React from 'react';
import styled from 'styled-components';
const HeaderStyled = (size) => styled[`h${size}`] ``;
const H = (props) => {
    const { size = '1', children, style } = props;
    const Header = HeaderStyled(size);
    return React.createElement(Header, { style: style }, children);
};
export default H;
//# sourceMappingURL=Header.js.map